import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function CareerModal({ isOpen, onClose, position }) {
    if (!position) return null;

    const accentCls = 'accent-' + (position.accent || 'sky');

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        className="themed-modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={onClose}
                    />
                    <motion.div
                        className={`themed-modal ${accentCls}`}
                        initial={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
                        exit={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        transition={{ duration: 0.25, ease: 'easeOut' }}
                    >
                        <div className="themed-modal-accent-bar" />
                        <div className="themed-modal-body">
                            <button
                                className="themed-modal-close"
                                onClick={onClose}
                                aria-label="Close"
                            >
                                ✕
                            </button>

                            <div className="themed-modal-hd-row">
                                <div className="themed-modal-icon">
                                    {position.company.charAt(0)}
                                </div>
                                <div>
                                    <h2 className="themed-modal-title">{position.title}</h2>
                                    <div className="themed-modal-subtitle">{position.company}</div>
                                </div>
                            </div>

                            <div className="themed-modal-meta-row">
                                <span className="themed-modal-meta-item">📅 {position.duration}</span>
                                <span className="themed-modal-meta-item">📍 {position.location}</span>
                            </div>

                            <p className="themed-modal-section-label">Overview</p>
                            <p className="themed-modal-text">{position.description}</p>

                            {position.achievements?.filter(a => a).length > 0 && (
                                <>
                                    <p className="themed-modal-section-label">Key Achievements</p>
                                    <ul className="themed-modal-list">
                                        {position.achievements.filter(a => a).map((achievement, idx) => (
                                            <li key={idx}>{achievement}</li>
                                        ))}
                                    </ul>
                                </>
                            )}

                            {position.technologies?.filter(t => t).length > 0 && (
                                <>
                                    <p className="themed-modal-section-label">Technologies &amp; Skills</p>
                                    <div className="tech-chips">
                                        {position.technologies.filter(t => t).map((tech, idx) => (
                                            <span key={idx} className="tech-chip">{tech}</span>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
